export const metricsData = state => state.metrics;

const getDeviceMetric = (deviceName, details) => {
  const device = details.filter(deviceMetric => deviceMetric.user_agent === deviceName);
  return device[0];
};

export const devicesMetrics = state => deviceName => {
  const device = getDeviceMetric(deviceName, state.metrics.details);

  const defaultData = {
    box_hits: 0,
    conclusion_average_time: 0,
    conclusion_rate: 0,
    completed_submissions_count: 0,
    uncompleted_submissions_count: 0,
  };

  if (!device) {
    return defaultData;
  }

  return device;
};




/** WEBPACK FOOTER **
 ** ./src/store/modules/report/metrics/getters.js
 **/